import Vue from 'vue'

export function guidePopover(Component, props) {
  const vm = new Vue({
    render(h) {
      console.log(h(Component,{ props }));
      return h(Component, { props })
    }
  }).$mount()
  document.querySelector('#base-popup').appendChild(vm.$el)
  const comp = vm.$children[0]
  comp.remove = () => {
    document.body.removeChild(vm.$el)
    vm.$destroy()
  }
  return comp
}
